<template>
  <div>
    <div v-if="!transact">
      <span v-if="tableData2.length != 0" style="margin-right: 20px">已申请分批发货信息</span><br>
      <Collapse v-for="(items, indexs) in tableData2" :key="indexs">
        <div slot="header">
          <div class="headerItem">
            <span>
              配送至:{{ items.receiptAddressInfo.province
              }}{{ items.receiptAddressInfo.city
              }}{{ items.receiptAddressInfo.county
              }}{{ items.receiptAddressInfo.receiptAddress }}
            </span>
            <!-- <span style="margin-left: 20px">
              实际结算金额:{{ items.settlementAmountTotal }}元
            </span> -->
            <span style="margin-left: 10px">
              发货数量总计：{{ items.productNumTotal }}
            </span>
          </div>
          <!-- <div />
          <div /> -->
        </div>
        <div
          v-for="(item, index) in items.partialInvoiceInfoList"
          :key="index"
          style="margin-top: 10px"
        >
          <span style="margin-right: 20px">分批申请单号:&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              style="color: #53a8ff; display: inline-block; cursor: pointer"
              @click="fpfh(item)"
            >
              {{ item.deliveryNum }}
            </span>
          </span>
          <span style="margin-right: 20px">申请日期:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.createTime }}</span>
          <span style="margin-right: 20px">发货单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.invoiceNum }}</span>
          <el-button
            v-if="item.processState == 1||item.processState == 7"
            type="primary"
            @click="revokeHttp(item)"
          >
            召回申请
          </el-button>
          <el-table
            v-loading="loading"
            :data="item.partialInvoiceProductList"
            border
            style="width: 100%; margin-top: 10px; margin-bottom: 10px"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              prop="itemIndex"
              label="序号"
              align="left"
              width="50"
              fixed="left"
            />
            <el-table-column prop="orderNumber" label="订单号" align="left" />
            <el-table-column
              prop="materialNumber"
              label="物品代码"
              align="left"
            />
            <el-table-column
              prop="productName"
              label="物品名称"
              align="left"
            />
            <el-table-column prop="productNum" label="数量" align="left" />
            <!-- <el-table-column
              prop="productPriceSigle"
              label="实际结算单价"
              align="left"
            />
            <el-table-column
              prop="settlementAmount"
              label="实际结算金额"
              align="left"
            /> -->
            <el-table-column
              prop="expectedDeliveryDate"
              label="客户期望发货日"
              align="left"
              width="200"
            />
            <el-table-column
              prop="agreedDate"
              label="约定交付日期"
              align="left"
              width="200"
            />
            <!-- <el-table-column prop="reason" label="待定原因" align="left" width="70" />
        <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
          </el-table>
        </div>
      </Collapse>
    </div>
    <div v-if="transact">
      <p>分批发货说明：</p>

      <p>1、工作日的10:30-23:59允许申请分批发货，新单当天不允许申请分批发货</p>

      <p>2、约定交付日期小于等于当天的才允许申请分批发货</p>

      <p>
        3、现销的申请分批发货后需先付款流程才能到订单员，赊销的申请分批发货后无需付款流程即可到订单员
      </p>
      <p style="margin-bottom: 20px">
        4、货运方式为供应商直发的产品预计在提交申请三天后发货
      </p>
      <span style="margin-right: 20px">未申请分批发货信息</span>
      <el-button
        type="primary"
        :disabled="applyButton"
        @click="applyDeliverGoods()"
      >
        申请分批发货
      </el-button>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%; margin-top: 10px; margin-bottom: 10px"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="left"
          fixed="left"
          :selectable="isCheckAgreedDate"
        />
        <el-table-column
          prop="itemIndex"
          label="序号"
          align="left"
          width="50"
        />
        <el-table-column prop="orderNumber" label="订单号" align="left" />
        <el-table-column
          prop="materialNumber"
          label="物品代码"
          align="left"
        />
        <el-table-column
          prop="productName"
          label="物品名称"
          align="left"
          width="200"
        />
        <el-table-column prop="productNum" label="未发货数量" align="left" />
        <!-- <el-table-column
          prop="productPriceSigle"
          label="实际结算单价"
          align="left"
        />
        <el-table-column
          prop="settlementAmount"
          label="实际结算金额"
          align="left"
        /> -->
        <el-table-column
          prop="freightAttributeName"
          label="货运方式"
          align="left"
        />
        <el-table-column
          prop="expectedDeliveryDate"
          label="客户期望发货日"
          align="left"
          width="200"
        />
        <el-table-column
          prop="agreedDate"
          label="约定交付日期"
          align="left"
          width="200"
        />
        <!-- <el-table-column prop="reason" label="待定原因" align="left" width="70" />
      <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
      </el-table>
      <div v-if="tableData2.length != 0" style="margin-right: 20px">
        已申请分批发货信息
      </div>
      <br>
      <Collapse v-for="(items, indexs) in tableData2" :key="indexs">
        <div slot="header">
          <div class="headerItem">
            <span>
              配送至:{{ items.receiptAddressInfo.province
              }}{{ items.receiptAddressInfo.city
              }}{{ items.receiptAddressInfo.county
              }}{{ items.receiptAddressInfo.receiptAddress }}
            </span>
            <!-- <span style="margin-left: 20px">
              实际结算金额:{{ items.settlementAmountTotal }}元
            </span> -->
            <span style="margin-left: 10px">
              发货数量总计：{{ items.productNumTotal }}
            </span>
          </div>
          <!-- <div />
          <div /> -->
        </div>
        <div
          v-for="(item, index) in items.partialInvoiceInfoList"
          :key="index"
          style="margin-top: 10px"
        >
          <span style="margin-right: 20px">分批申请单号:&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              style="color: #53a8ff; display: inline-block; cursor: pointer"
              @click="fpfh(item)"
            >
              {{ item.deliveryNum }}
            </span>
          </span>
          <span style="margin-right: 20px">申请日期:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.createTime }}</span>
          <span style="margin-right: 20px">发货单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.invoiceNum }}</span>
          <el-button
            v-if="item.processState == 1||item.processState == 7"
            type="primary"
            @click="revokeHttp(item)"
          >
            召回申请
          </el-button>
          <el-table
            v-loading="loading"
            :data="item.partialInvoiceProductList"
            border
            style="width: 100%; margin-top: 10px; margin-bottom: 10px"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              prop="itemIndex"
              label="序号"
              align="left"
              width="50"
              fixed="left"
            />
            <el-table-column prop="orderNumber" label="订单号" align="left" />
            <el-table-column
              prop="materialNumber"
              label="物品代码"
              align="left"
            />
            <el-table-column
              prop="productName"
              label="物品名称"
              align="left"
            />
            <el-table-column prop="productNum" label="数量" align="left" />
            <!-- <el-table-column
              prop="productPriceSigle"
              label="实际结算单价"
              align="left"
            /> -->
            <!-- <el-table-column
              prop="settlementAmount"
              label="实际结算金额"
              align="left"
            /> -->
            <el-table-column
              prop="expectedDeliveryDate"
              label="客户期望发货日"
              align="left"
              width="200"
            />
            <el-table-column
              prop="agreedDate"
              label="约定交付日期"
              align="left"
              width="200"
            />
            <!-- <el-table-column prop="reason" label="待定原因" align="left" width="70" />
        <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
          </el-table>
        </div>
      </Collapse>

      <el-dialog
        title="申请分批发货"
        :visible.sync="dialogVisible"
        width="1000px"
        class="partShipment"
        @open="partDialogOpen"
        @close="closeDialog"
      >
        <p>
          产品信息<span
            style="display: inline-block; color: red; margin-left: 50px"
          >注：货运方式为供应商直发的产品预计在提交申请三天后发货</span>
        </p>

        <el-table
          v-loading="loading"
          :data="tableData_dialog"
          border
          style="width: 100%; margin-top: 10px; margin-bottom: 10px"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column
            prop="itemIndex"
            label="序号"
            align="left"
            width="50"
            fixed="left"
          />
          <el-table-column prop="orderNumber" label="订单号" align="left" />
          <el-table-column
            prop="materialNumber"
            label="物品代码"
            align="left"
          />
          <el-table-column prop="productName" label="物品名称" align="left" />
          <el-table-column prop="productNum" label="数量" align="left" />
          <!-- <el-table-column
            prop="productPriceSigle"
            label="实际结算单价"
            align="left"
          /> -->
          <!-- <el-table-column
            prop="settlementAmount"
            label="实际结算金额"
            align="left"
          /> -->
          <el-table-column
            prop="freightAttributeName"
            label="货运方式"
            align="left"
            width="100"
          />
          <el-table-column
            prop="expectedDeliveryDate"
            label="客户期望发货日"
            align="left"
            width="200"
          />
          <el-table-column
            prop="agreedDate"
            label="约定交付日期"
            align="left"
            width="200"
          />
          <!-- <el-table-column prop="reason" label="待定原因" align="left" width="70" />
        <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
        </el-table>
        <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
          原信息
        </p>
        <p>
          <span>收货地址：</span>
          <span>{{
            findContractInfoForPartialInvoiceMessage.receiptAddress
          }}</span>
        </p>
        <p>
          <span>运输方式：</span>
          <span>{{
            findContractInfoForPartialInvoiceMessage.modeOfShipping
          }}</span>
          <span style="margin-left: 20px">承运商：</span>
          <span>{{ findContractInfoForPartialInvoiceMessage.carrier }}</span>
        </p>
        <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
          变更后信息
        </p>
        <p>
          <span>变更后收货地址：</span>
          <span>{{ address.receiverName }}</span>
          <span>{{ address.province }}</span>
          <span>{{ address.city }}</span>
          <span>{{ address.county }}</span>
          <span>{{ address.receiptAddress }}</span>
          <span>{{ address.receiverPhone }}</span>
          <span>
            <el-button
              v-if="address.receiverName"
              type="text"
              style="padding: 0; margin-left: 15px"
              @click="updateAdd"
            >更改地址</el-button>
            <el-button
              v-if="!address.receiverName"
              type="text"
              style="padding: 0; margin-left: 15px"
              @click.stop="showAddress = true"
            >选择地址</el-button>
          </span>
        </p>
        <div v-loading="loadingChange">
          <p>
            <span>变更后运输方式：</span>
            <span class="rj-baseinfo__item">
              <el-radio-group
                v-model="shippingType"
                @change="shippingTypeChange"
              >
                <el-radio :label="0">陆运</el-radio>
                <el-radio :label="1" :disabled="isHaveBattery">航空</el-radio>
              </el-radio-group>
            </span>
            <span>变更后承运商：</span>
            <span>
              <el-select
                v-model="carrierChangeValue"
                :disabled="isCarrierChangeValue"
                @change="carrierChange"
              >
                <el-option
                  v-for="item in changeBussinessOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </span>
          </p>
          <p>
            <span style="margin-right: 30px">运费差价：{{ freight }}元</span>
            <span v-if="this.freight != 0" v-show="false" class="rj-baseinfo__label">运费支付方式：</span>
            <span v-if="this.freight != 0" v-show="false" class="rj-baseinfo__item">
              <el-radio-group v-model="form.isRebate" @change="changisRebate">
                <el-radio :label="false">现金</el-radio>
                <el-radio :label="true">返利</el-radio>
              </el-radio-group>
              <template v-if="form.isRebate">
                使用金额: {{ form.rebateAmount }} 元
                <!-- eslint-disable-next-line vue/require-component-is -->
                <component
                  v-bind="dialogNode"
                  @chooesSuccess="chooseRebateSuccess"
                /> </template><br>
            </span>
          </p>
        </div>
        <p>
          <span>唛头单号:</span>
          <el-input
            v-model.trim="findContractInfoForPartialInvoiceMessage.marksNum"
            style="width: 150px; margin-right: 10px"
            placeholder="请输入唛头单号"
          />
          <span>授权邮箱:</span>
          <el-input
            v-model.trim="
              findContractInfoForPartialInvoiceMessage.authorizationEmail
            "
            style="width: 200px"
            placeholder="请输入授权邮箱"
          />
        </p>
        <p>
          <span
            style="display: inline-block; margin-top: 5px; margin-bottom: 5px"
          >收货回执及到货验收要求：</span>
          <el-input
            v-model.trim="
              findContractInfoForPartialInvoiceMessage.receiptArrivalAcceptanceRequirements
            "
            type="textarea"
            :rows="3"
            placeholder="请输入收货回执及到货验收要求"
            maxlength="200"
            show-word-limit
          />
        </p>
        <p>
          <span>回执附件</span>
          <el-upload
            action=""
            multiple
            :show-file-list="false"
            :http-request="uploadaction"
            style="display: inline-block; margin: 0 10px"
          >
            <el-button type="primary">
              上传附件
            </el-button>
          </el-upload>
        </p>
        <div v-for="(item, index) in fileList" :key="index">
          <span style="margin-right: 10px; color: #409eff">{{
            item.fileName
          }}</span>
          <span
            style="color: #409eff; cursor: pointer"
            @click="deleteFile(index)"
          ><i class="el-icon-error" /></span>
        </div>
        <!-- <div>
          111111
        </div> -->
        <p>
          <span
            style="display: inline-block; margin-top: 5px; margin-bottom: 5px"
          >发货备注说明：</span>
          <el-input
            v-model.trim="
              findContractInfoForPartialInvoiceMessage.deliverRemark
            "
            type="textarea"
            :rows="3"
            placeholder="请输入发货备注说明"
            maxlength="200"
            show-word-limit
          />
        </p>
        <p>
          <span
            style="display: inline-block; margin-top: 5px; margin-bottom: 5px"
          >备注：</span>
          <el-input
            v-model.trim="findContractInfoForPartialInvoiceMessage.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          />
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" @click="dialogVisible = false">关 闭</el-button>
          <el-button type="primary" :loading="subLoading" @click="submit">提交申请</el-button>
        </span>
      </el-dialog>
      <address-box
        :prop-open.sync="showAddress"
        @chooseAddress="changeAddress"
        @ChangeDatas="ChangeDatas"
      />
    </div>
    <el-dialog
      title="召回原因"
      :visible.sync="dialogVisibleBack"
      width="360px"
      @close="revokeDialogClose"
    >
      <el-input
        v-model="deleteReason"
        type="textarea"
        placeholder="请输入召回原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="mini" type="text" @click="dialogVisible = false">取消</el-button> -->
        <el-button type="primary" size="mini" @click="handleDeleteDebit">确定</el-button>
      </span>
    </el-dialog>
    <partShipCheck
      :id="partId"
      :dialog-form-visible="dialogFormVisible"
      @on-status-dialog="updataDialogFormVisible"
    />
    <logisticsNumber
      :dialog-form-visible-logist="dialogFormVisibleLogist"
      :form="formNum"
      @on-status-dialog="updataDialogFormVisibleLogist"
    />
  </div>
</template>
<script type="es6">
import axios, {
  findNotAppliedPartialShipmentList,
  getAfterAgreedProduct,
  findPartialInvoiceInfoListByMasterContractId,
  revokeApply,
  findContractInfoForPartialInvoice,
  saveApplyPartialShipment,
  getReceiptAddressInfoModel,
  getReceiptAddressByContractId,
  getEditRebateUsedList,
  getRebateSummaryAgentInfo,
  getPartialShipmentFreight,
  attachmentGetToken
} from '@/API';
import Collapse from '@/components/Collapse';
import addressBox from '@/views/address/index.vue';
import { MathAdd, MathMulti } from '@/libs/util';
import lookserialNumber from '../../../Chief/contract/common/lookserialNumber.vue';
import logisticsNumber from '../partShipCheck/logisticsNumber';
import partShipCheck from '../partShipCheck';
import { checkPartialShipmentCompliance } from '@/libs/partialShipmentCompliance';
// import rebateUse from './rebateUse';
// import rebateUsedList from './rebateUsedList.vue';
import { mapState } from 'vuex';
/* eslint-disable */
export default {
  data () {
    return {
      applyButton: true,//按钮是否置灰
      transact: false, //是否办理
      subLoading: false,
      tableData: [],
      tableData2: [],
      partId: '',
      tableData_dialog: [],
      isHaveBattery: false,
      carrierChangeValue: "默认物流",
      dialogFormVisibleLogist: false,
      dialogFormVisible: false,
      formNum: {},
      isCarrierChangeValue: false,//承运商是否可点击
      rebateListVo: [],
      findContractInfoForPartialInvoiceMessage: {
        authorizationEmail: null,
        carrier: "",
        marksNum: "",
        deliverRemark: "",
        modeOfShipping: "",
        receiptAddress: "",
        receiptArrivalAcceptanceRequirements: "",
        remark: "",
      },
      loading: false,
      loadingChange: false,
      dialogVisible: false,
      showAddress: false,
      address: {},
      shippingType: 0,
      freight: "0", //运费差价
      form: {
        isRebate: false,
        rebateAmount: "",
      },

      changeBussiness: "",
      changeBussinessOptions: ["默认物流", "顺丰"],
      goodsReceipt: "",
      goodsRemark: "",
      multipleSelection: [],
      dialogNode: {
        is: "",
        allow: 0,
        availableRebateAmount: 0,
        rebateUsedList: [],
      },
      // 文件参数
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileList: [],
      // 召回参数
      dialogVisibleBack: false,
      deleteReason: '',
      revokedata: {}
    };
  },
  props: {
    contractStatus: {
      type: [String, Number],
      required: true,
    },
    contractType: {
      type: [String, Number],
      required: '',
    },
    shippingTypeOld: {
      type: [Object, Number],
      required: 0,
    },
    carrierOld: {
      type: [String, Object],
      required: '',
    },
    sourceModifyAddress: {
      type: [Boolean, Object],
      required: false,
    },
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {
    addressBox,
    // rebateUse,
    // rebateUsedList,
    logisticsNumber,
    partShipCheck,
    lookserialNumber,
    Collapse
  },
  computed: {
    ...mapState({
      salesType: (state) => state.enumeration.salesType,
      shipType: (state) => state.enumeration.shipType,
    }),
    allowUserRate () {
      return MathMulti(this.form.orderSales, 0.3);
    },
  },
  watch: {
    freight (val) {
      this.dialogNode.allow = this.freight; //最大返利金额   运费差价字段
    },
  },
  methods: {
    getArrEqual (arr1, arr2) {
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j].itemIndex === arr2[i].itemIndex) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    arrysaleProductCode (arr1, arr2) {
      //    取arr2中的每个元素和arr1每个元素比较
      var n = arr1.filter(item => {
        return !arr2.includes(item.saleProductCode)
      })
      return n
    },
    // saleProductCode数据抽取 组装
    saleProductCode (data) {
      return this.arrysaleProductCode(this.tableData, data)
    },
    arryUnableItemProduct (arr1, arr2) {
      var n = arr1.filter(item => {
        return !arr2.includes(item.itemIndex)
      })
      return n
    },

    // itemIndex数据抽取 组装
    UnableItemProduct (data) {
      return this.arryUnableItemProduct(this.tableData, data)
    },
    deleteFile (tag) {
      this.fileList.splice(tag, 1);
    },
    //initToken
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    //文件上传
    uploadaction (upload) {
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };

      axios.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fileList.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
          })
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    //初始化数据
    initData () {
      this.loading = true;
      findNotAppliedPartialShipmentList({
        strContractCode: this.$route.params.contractNum,
      })
        .then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === "200") {
            this.tableData = json.data;
            //默认添加属性字段是否勾选
            //接口返回后，调用 交期大于今天的硬件和软件 接口
            getAfterAgreedProduct({
              contractId: this.$route.query.id,
              productList: this.tableData
            }).then((res) => {
              this.applyButton = false;
              let needCheckData = [];
              let result = res.data.data;
              // let result = {
              //   unableHostProduct: ['NH11501287','NG10404960','NG13100120','NH10301577','NG10102487','NH10301575','NG10404009','NG10102482','NG10102126','NG10101597','NG10102124','NG10102483','NG10102328',],
              //   unableItemProduct: []
              // };
              if (result.unableHostProduct.length != 0 || result.unableItemProduct.length != 0) {
                if (result.unableHostProduct.length == 0 && result.unableItemProduct.length != 0) {
                  needCheckData = this.UnableItemProduct(result.unableItemProduct);
                } else if (result.unableHostProduct.length != 0 && result.unableItemProduct.length == 0) {
                  needCheckData = this.saleProductCode(result.unableHostProduct);
                } else {
                  needCheckData = this.getArrEqual(this.saleProductCode(result.unableHostProduct), this.UnableItemProduct(result.unableItemProduct));
                }
                //去除时间
                let newData = [];
                needCheckData.forEach(item => {
                  if (item.agreedDate) {
                    newData.push(item)
                  }
                });
                needCheckData = newData
              } else {
                this.tableData.forEach(item => {
                  if (item.agreedDate) {
                    needCheckData.push(item)
                  }
                })
              }
              //设置新的需要传入数组 TODO 是否需要去重过程 
              this.toggleSelection(needCheckData)
              //
            }).catch((err) => {
              this.applyButton = false;
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
      findPartialInvoiceInfoListByMasterContractId({ id: this.$route.query.id })
        .then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === "200") {
            this.tableData2 = json.data.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    toggleSelection (rows) {
      this.$nextTick(() => {
        rows.forEach(row => {
          // 不能自己自定义对象来设置选中（原因如下分析），那我可以从列表中找到需要选中的那个对象，然后把它拿过来作为选中的项就可以了
          this.$refs.multipleTable.toggleRowSelection(this.tableData.find(item => {
            return row.itemIndex == item.itemIndex;  // 注意这里寻找的字段要唯一
          }), true);
        });
      })
    },
    //实际结算金额
    trueAccount () {
      let cont = 0;
      this.tableData_dialog.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    // 运输方式改变初始化承运商
    shippingTypeChange () {
      this.fecthFreightDifference();
    },
    // 承运商改变修改运费值
    carrierChange () {
      if (this.carrierChangeValue === '默认物流' && this.contractType !== 'SMB分销下单') {
        this.freight = 0;
      } else {
        this.fecthFreightDifference();
      }
    },
    // 校验是否含有电池和计算运费差价接口
    async fecthFreightDifference () {
      this.loadingChange = true;
      this.isHaveBattery = false;
      let params = {
        contractNum: this.$route.params.contractNum,
        shippingType: this.shippingType,
        receiptAddressId: this.address.id,
        partialInvoiceProductList: this.multipleSelection,
        carrier: this.carrierChangeValue
      };
      const res = await getPartialShipmentFreight(params);
      this.loadingChange = false;
      const json = res.data;
      if (json.status === "200") {
        this.freight = json.data;
        //默认物流 +陆运 = 0;
        if (this.carrierChangeValue == '默认物流' && this.shippingType == 0 && this.contractType !== 'SMB分销下单') {
          this.freight = 0;
        }
      } else if (json.status === "7100023") {
        // 包含电池状态码：7100023，不能选择航空
        this.isHaveBattery = true;

        this.getType()
      } else {
        this.getType()
      }
      // 如果是航空，禁用选择承运商
      if (this.shippingType == 1) {
        this.isCarrierChangeValue = true;
      } else {
        this.isCarrierChangeValue = false;
      }
    },
    //判断当前状态 返回不同 shippingType 
    getType () {
      this.shippingType = 0;
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.label === "未发货数量") {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === "数量") {
          sums[index] = this.productNum(param.data);
          return;
        }
        // if (column.label === "实际结算金额") {
        //   sums[index] = this.settlementAmount(param.data);
        // }
      });
      return sums;
    },
    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    async getAddress () {
      var res = await getReceiptAddressByContractId(this.$route.query.id);
      const json = res.data;
      if (json.status === "200") {
        let data = json.data;
        if (data === null) {
          data = [];
        }
        this.address = data;
        this.findContractInfoForPartialInvoiceMessage.authorizationEmail = this.address.email

        this.$emit("chooseAddress", json.data);
      } else {
        console.log(json);
      }
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      //调用运费接口
      this.fecthFreightDifference();
      this.$emit("chooseAddress", val);
      this.$emit("changeAddress");
    },
    // 申请发货
    applyDeliverGoods () {

      if (this.multipleSelection.length > 0) {
        // 循环 multipleSelection  tableData 取剩下的值
        // for (var i = 0; i < otherData.length; i++) {
        //   for (var j = 0; j < this.multipleSelection.length; j++) {
        //     if (otherData[i].itemIndex === this.multipleSelection[j].itemIndex) {
        //       console.log(i, 'iiiiii')
        //       otherData.splice(i, 1);
        //       i--;
        //     }
        //   }
        // }
        const msKeys = this.multipleSelection.map(item => item.itemIndex)

        const filterOD = this.tableData.filter(item => {
          if (!msKeys.includes(item.itemIndex)) return item
        })
        //判断 未勾选的如果有硬件&&勾选的没有硬件 不让提交
        let otherStatus = false;
        let chanceStatus = true;
        for (var i = 0; i < filterOD.length; i++) {
          if (filterOD[i].flag) {
            otherStatus = true;
          }
        }
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].flag) {
            chanceStatus = false;
          }
        }
        if (otherStatus && chanceStatus) {
          this.$message.error("软件对应的硬件没有齐套，请等硬件齐套后再一起申请分批发货");
          return
        } else {
          this.dialogVisible = true;
        }

      } else {
        this.$message.error("请勾选需要分批发货产品");
      }
      //获取 选中的产品 和未选中的产品 
      // console.log(this.multipleSelection, 'this.multipleSelection');
      // console.log(this.tableData, 'this.tableData');


    },
    //申请发货打开
    async partDialogOpen () {
      // console.log(this.sourceModifyAddress, 'sourceModifyAddress')//是否修改过地址
      //判断是否是分校下单
      if (this.contractType === 'SMB分销下单') {
        this.carrierChangeValue = this.carrierOld ? this.carrierOld : '默认物流'
        this.shippingType = this.shippingTypeOld ? this.shippingTypeOld : 0
      }
      //请求回显接口
      // this.getAddress();//地址查询
      var res = await getReceiptAddressByContractId(this.$route.query.id);
      const json = res.data;
      if (json.status === "200") {
        let data = json.data;
        if (data === null) {
          data = [];
        }
        this.address = data;
        // this.fecthFreightDifference(); //运费查询
        this.$emit("chooseAddress", json.data);
      } else {
      }
      this.getEditRebateUsedList(); //返利查询

      let parmars = {
        productList: this.multipleSelection,
        contractId: this.$route.query.id,
      };
      this.tableData_dialog = this.multipleSelection;

      findContractInfoForPartialInvoice(parmars)
        .then((res) => {
          let json = res.data;

          if (json.status === "200") {
            this.findContractInfoForPartialInvoiceMessage = json.data;
            // this.address = data;
            // this.$emit('chooseAddress', json.data);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //点击更改地址   查看当前SMB分销平台订单（允许多次修改地址）
    updateAdd () {
      if (this.contractType === 'SMB分销下单' && this.sourceModifyAddress) {
        this.$message.error('抱歉，您已修改过发货地址，不允许再次修改地址');
        return false;
      }
      this.showAddress = true
    },
    closeDialog () {
      // 重置
      this.shippingType = 0;
      this.freight = 0;
      this.carrierChangeValue = "默认物流";
      this.form.isRebate = false;
      this.fileList = [];
    },
    //dialog 提交按钮 saveApplyPartialShipment
    async submit () {
      this.subLoading = true;
      let parmars = {
        masterContractId: this.$route.query.id,
        masterContractNum: this.$route.params.contractNum,
        masterProjectName: this.$route.query.masterProjectName,
        partialInvoiceFile: this.fileList,
        detail: {
          id: null,
          partialId: null,
          partialAddressId: this.address.id,
          receiptAddressId: this.findContractInfoForPartialInvoiceMessage
            .receiptAddressId,
          modeOfShipping: this.shippingType === 1 ? "航空" : "陆运", //货运方式
          carrier: this.carrierChangeValue, //承运商
          freight: this.freight, //运费差价
          freightPayType: this.form.isRebate ? 1 : 0, //支付方式
          freightUseRebate: null, //null
          amountSum: this.trueAccount(), //合计金额
          remark: this.findContractInfoForPartialInvoiceMessage.remark, //备注
          deliverRemark: this.findContractInfoForPartialInvoiceMessage
            .deliverRemark,
          receiptArrivalAcceptanceRequirements: this
            .findContractInfoForPartialInvoiceMessage
            .receiptArrivalAcceptanceRequirements,
          authorizationEmail: this.findContractInfoForPartialInvoiceMessage
            .authorizationEmail, //云桌面
          marksNum: this.findContractInfoForPartialInvoiceMessage.marksNum, // 唛头单号
          approvalOpinion: "", //审批意见
        },
        rebateListVo: this.rebateListVo,
        partialInvoiceProductList: this.multipleSelection,
      };
      try {
        const canSubmit = await checkPartialShipmentCompliance({
          businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_CHANNEL_SUBMIT',
          originalBizId: parmars.masterContractNum || parmars.masterContractId,
          contractInfo: this.findContractInfoForPartialInvoiceMessage,
          address: this.address,
          products: parmars.partialInvoiceProductList,
          projectName: parmars.masterProjectName
        });
        if (!canSubmit) {
          this.subLoading = false;
          return;
        }
      } catch (error) {
        this.subLoading = false;
        this.$message.error(error.message || '出口合规检测失败');
        return;
      }
      saveApplyPartialShipment(parmars)
        .then((res) => {
          let json = res.data;
          this.subLoading = false;
          if (json.status === "200") {
            this.findContractInfoForPartialInvoiceMessage = json.data;
            // this.address = data;
            // this.$emit('chooseAddress', json.data);
            this.dialogVisible = false;
            this.$message.success('提交成功')
            //新增跳转到列表
            // this.$store.commit('pagesTemporary/SETChiefContractListTabActive', '9');
            this.$router.go(-1);

          }
        })
        .catch(() => {
          this.loading = false;
          this.subLoading = false;
        });
    },
    //设置约交日期 是否可编辑
    isCheckAgreedDate (row) {
      return false
    },
    //设置时间不可选 并且勾选 是否大于今天 
    compare (date1) {
      var oDate1 = new Date(row.agreedDate);
      if (oDate1 > new Date()) {
        return true
      } else {
        //勾选
        return false
      }

    },
    // dialog 关闭
    revokeDialogClose () {
      this.deleteReason = '';
    },
    handleDeleteDebit () {
      let row = this.revokedata;
      if (this.deleteReason === '') {
        this.$message.error('请输入召回原因');
        return;
      }
      revokeApply({ 'id': row.id, 'approvalOpinion': this.deleteReason }).then((res) => {
        let json = res.data;
        // this.$refs.gridTable.doClose();
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '召回成功 !'
          });
          this.dialogVisibleBack = false;
          this.initData();
        }
      }).catch(() => {
      });
    },
    // 撤销接口
    revokeHttp (row) {
      this.revokedata = row;
      this.dialogVisibleBack = true;
    },

    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id)
          .then((res) => {
            let json = res.data;
            if (json.status === "200") {
              if (!json.data.isDelete) {
                this.address = json.data;
              } else {
                this.address = {};
              }
            }
          })
          .catch(() => { });
      }
    },
    // 返利
    changisRebate (val) {
      if (!val) {
        this.form.rebateAmount = 0;
        this.dialogNode.rebateUsedList = [];
      }
    },
    chooseRebateSuccess (val) {
      this.rebateListVo = [];
      //转化数组格式
      val.list.forEach((item) => {
        this.rebateListVo.push({
          rebateNum: item.rebateNumber,
          rebateTypeName: item.strRebateType,
          rebateAmount: item.useAmount,
        });
      });
      // 赋值过程toFixed();
      this.form.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },
    //返利 接口
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.$route.params.contractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            if (json.data.length) {
              this.dialogNode.rebateUsedList = json.data;
              this.dialogNode.is = "rebate-used-list";
            } else {
              this.dialogNode.is = "rebate-use";
            }
          }
        })
        .catch(() => { });
      getRebateSummaryAgentInfo({ contractNum: this.$route.params.contractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.dialogNode.availableRebateAmount = json.data.availableAmount;
            
          }
        })
        .catch(() => { });
    },
    istransact () {
      let transact = this.$route.query.transact;
      if (transact) {
        this.transact = true;
      } else {
        this.transact = false;
      }
    },
    fpfh (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    //物流单号接口
    logisticClick (row) {
      this.formNum = {
        invoiceNum: row.invoiceNum,
        logisticsNum: row.logisticsNum
      };
      this.dialogFormVisibleLogist = true;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    }
  },
  mounted () {
    this.initData();
    this.istransact();
    this.initToken();
  },
};
</script>
<style scope>
.partShipment p {
  margin: 5px 0;
}
</style>
